<nb-card [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="giant">
  <app-datatable
    [columns]="columns"
    [rows]="roomChampionRows"
    [searchable]="searchable"
    [searchControlSettings]="searchControlSettings"
    (filterChange)="onFilterChange($event)"
    [initialFilters]="filters"
    [isTopSection]="true"
    [headerHeight]="headerHeight"
  >
  </app-datatable>
</nb-card>
